// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { withdrawalKinds } from '../statuses';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class WithdrawalTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingWithdrawalTransactions';
        this.Server =
            this.props.context.getState().server.accountingWithdrawalTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['systemAccount.name'];
        this.showDatePicker = false;

        const defaultHead = [
            {
                id: 'systemAccountId',
                label: 'systemAccount',
                alignRight: false,
                cell: 'Select',
                from: 'accountingSystemAccounts',
                show: 'name',
                object: 'systemAccount',
                displayGrid: true
            },
            {
                id: 'amount',
                label: 'amount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'comment',
                label: 'comment',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true
            },
            {
                id: 'kind',
                label: 'withdrawalKind',
                alignRight: false,
                cell: 'Items',
                items: Object.keys(withdrawalKinds),
                displayGrid: true
            },
            {
                id: 'paymentDate',
                label: 'paymentDate',
                alignRight: false,
                cell: 'Date',
                displayGrid: true,
                default: 'today',
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
